import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import axios from "../../../../axios";
import { errorToast, successToast } from "../../../../utils/toast";

const ChangePlanModal = ({
  isOpen,
  onClose,
  userId,
  currentPlan,
  onSuccess,
}) => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    const fetchCourses = async () => {
      try {
        const res = await axios.get("/getAllCourses");
        setCourses(res?.data?.result || []);
      } catch (err) {
        errorToast("Failed to fetch courses");
      }
    };

    fetchCourses();
  }, [isOpen]);

  useEffect(() => {
    setSelectedCourse(currentPlan || "");
  }, [currentPlan]);

  const handleSubmit = async () => {
    if (!selectedCourse) {
      return errorToast("Please select a course");
    }

    try {
      setLoading(true);

      await axios.post("/changeUserPlanByAdmin", {
        userId,
        courseId: selectedCourse,
      });

      successToast("Plan changed successfully");

      onClose();

      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      errorToast(
        err?.response?.data?.message || "Unable to change plan"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>Change User Plan</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <label className="font-medium mb-2 block">
            Select Course
          </label>

          <select
            className="w-full border rounded-md p-2"
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
          >
            <option value="">Select Course</option>

            {courses.map((course) => (
              <option key={course._id} value={course._id}>
                {course.planName}
              </option>
            ))}
          </select>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancel
          </Button>

          <Button
            colorScheme="purple"
            isLoading={loading}
            onClick={handleSubmit}
          >
            Change Plan
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ChangePlanModal;